module.exports = __webpack_public_path__ + "fonts/gaxon.00fcca8e.ttf";